
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import CatalogListGrid from "../../../common/catalog/CatalogListGrid";
import CatalogListSection from "../../../common/catalog/CatalogListSection";
import CatalogEmptyState from "../../../common/catalog/CatalogEmptyState";
import { getCatalogEmptyCopy } from "../../../common/catalog/catalogEmptyCopy";
import { fetchCatalogListPage } from "../../../common/catalog/fetchCatalogListPage";
import Paginator from "../../../common/paginator/Paginator";
import Skeleton from "../../../common/loading/Skeleton";
import Webinar from "../common/Webinar";

export default function WebinarSection({ isDesktop, query, expertiseId }) {
	const navigate = useNavigate();
	const [webinars, setWebinars] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchWebinars(1);
	}, []);

	useEffect(() => {
		if (page !== 1) {
			setPage(1);
		}
		fetchWebinars(1);
	}, [query, expertiseId]);

	useEffect(() => {
		fetchWebinars(page);
	}, [page]);

	function fetchWebinars(currentPage) {
		if (isLoading) {
			return;
		}
		let queryParam = query ? query : '';
		let expertiseIdParam = expertiseId ? expertiseId : '';
		setIsLoading(true);
		fetchCatalogListPage({
			fetchPage: (params) => api.webinarSearch(params),
			baseParams: {
				query: queryParam,
				expertise_id: expertiseIdParam,
			},
			displayPage: currentPage,
			listKey: "webinars",
		})
			.then(({ items, maxPage }) => {
				setWebinars(items);
				setMaxPageNum(maxPage);
				setIsLoading(false);
			})
			.catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	const emptyCopy = getCatalogEmptyCopy({
		itemSingular: "وبینار",
		query,
		hasExtraFilter: Boolean(expertiseId),
	});

	const pagination =
		webinars.length >= 1 && maxPageNum >= 2 ? (
			<Paginator
				currentPage={page}
				maxPageNum={maxPageNum}
				isLoading={isLoading}
				onChange={(newPage) => {
					setPage(newPage);
				}}
			/>
		) : null;

	return (
		<CatalogListSection pagination={pagination}>
			{webinars.length === 0 && isLoading && (
				<Skeleton variant="grid" type="webinar" count={8} />
			)}
			{webinars.length >= 1 && (
				<CatalogListGrid isDesktop={isDesktop}>
					{webinars.map((webinar) => (
						<Webinar key={webinar.id} webinar={webinar} />
					))}
				</CatalogListGrid>
			)}
			{webinars.length === 0 && !isLoading && !errorMessage && (
				<CatalogEmptyState
					message={emptyCopy.message}
					hint={emptyCopy.hint}
					actionLabel={emptyCopy.showClear ? "پاک کردن جستجو" : undefined}
					onAction={
						emptyCopy.showClear
							? () => navigate("/webinar_list/")
							: undefined
					}
				/>
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</CatalogListSection>
	)
}
